import React from "react";
import type { RevenueTrendItem } from "../type";
import { colors } from "../../../utils/colors";
import { useApp } from "../../../contexts/AppContext";
import { GenericBarChart, GenericBarChartRow } from "./GenericBarChart";
import { EMPTY_STATE_MESSAGE, REVENUE_SERIES_NAME } from "../../../utils/consts";

const monthShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const toChartRows = (series: RevenueTrendItem[]) =>
  series.map((p) => ({
    label: `${monthShort[p.month - 1] ?? p.month} ${p.year}`,
    value: Number(p.total_revenue),
  }));


export interface RevenueTrendChartProps {
  title?: string;
  loading?: boolean;
  series: RevenueTrendItem[];
}

export const RevenueTrendChart: React.FC<RevenueTrendChartProps> = ({
  title,
  loading = false,
  series,
}) => {
  const { drawerOpen } = useApp();

  const rows: GenericBarChartRow[] = toChartRows(series);

  return (
    <GenericBarChart
      title={title}
      data={rows}
      seriesName={REVENUE_SERIES_NAME}
      loading={loading}
      height={400}
      minHeight={400}
      emptyMessage={EMPTY_STATE_MESSAGE}
      legendTop={8}
      legendRight={50}
      barWidth="35%"
      xAxisLabelColor={colors.black}
      xAxisLabelFontSize="0.625rem"
      xAxisLabelFontWeight={500}
      yAxisLabelColor={colors.chart_gray}
      yAxisLabelFontSize="0.6875rem"
      xAxisRotateThreshold={5}
      defaultBarColor={colors.chart_blue}
      tooltipValueFormatter={(v: number) =>
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(v)
      }
      yAxisValueFormatter={(val: number) =>
        val >= 1_000_000
          ? `${(val / 1_000_000).toFixed(2)}M`
          : Number(val).toFixed(2)
      }
      resizeTrigger={drawerOpen}
    />
  );
};
